import { Popover } from '@mantine/core';
import React from "react";
import { IoIosArrowForward } from "react-icons/io";

function HeaderSearchbar({ page, placeholder }) {
  return (
    <div className="dashboard_card_searchbar_container">
      {/* text  */}

      <div className="text-area">
        <div className="text">All {page}</div>
        <div>
          <IoIosArrowForward size={30} />
        </div>
      </div>

      {/* serach  */}

      <div className="search-area">
        <div className="search">
          <input
            className="search-input-for-top-dashbard"
            type="search"
            placeholder={placeholder}
          />
        </div>

        <div className="filter">

        <Popover width={300} position="bottom" withArrow shadow="md">
      <Popover.Target>
        <div>Sort by : {page} publishing date </div>
      </Popover.Target>
      <Popover.Dropdown>
        <ul>
            <li>Recentt {page} </li>
            <li>Old {page} </li>
        </ul>
      </Popover.Dropdown>
    </Popover>


        </div>
      </div>
    </div>
  );
}

export default HeaderSearchbar;
